"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformMangoPayInToPayInModel = void 0;
function transformMangoPayInToPayInModel(mangoPayIn) {
    return {
        payInId: mangoPayIn.Id,
        status: mangoPayIn.Status,
        result: `${mangoPayIn.ResultCode}: ${mangoPayIn.ResultMessage}`,
        resultMessage: mangoPayIn.ResultMessage,
        resultCode: mangoPayIn.ResultCode,
        tag: mangoPayIn.Tag,
    };
}
exports.transformMangoPayInToPayInModel = transformMangoPayInToPayInModel;
//# sourceMappingURL=transformMangoPayInToPayInModel.js.map